import React from "react";

const DowntimeBanner = () => {
  const utcHour = new Date().getUTCHours();
  const isDowntimeWindow = utcHour >= 20 || utcHour < 6;
  const isStaging = process.env.REACT_APP_ENVIRONMENT === "staging";

  const shouldShowBanner = isDowntimeWindow && isStaging;

  if (!shouldShowBanner) {
    return null;
  }

  return (
    <div
      className="px-2 py-3 text-center"
      style={{
        backgroundColor: "#D1E6E2",
        color: "#103575",
        fontFamily: "ageo-regular",
      }}
    >
      <p className="m-0">
        This staging environment is unavailable daily between 8:00 PM and 6:00
        AM UTC
      </p>
    </div>
  );
};

export default DowntimeBanner;
